export default function Hero({ resolveCount, flaggedCount, savedCount }) {
  return (
    <section className="hero panel">
      <div className="hero-copy">
        <div className="eyebrow">Grow Room Audit</div>
        <h1>Calendar first. Rooms next. Rebuild only what needs attention.</h1>
        <p>
          The interface is now centered on weekly room events, a short list of
          rooms worth auditing, and a simpler rebuild board where every output,
          sensor, service, and virtual can be placed, connected, checked, and
          saved in the room's current state.
        </p>
      </div>
      <div className="hero-meta">
        <div className="stat-card">
          <span>Resolve Queue</span>
          <strong>{resolveCount}</strong>
        </div>
        <div className="stat-card">
          <span>Flagged Rooms</span>
          <strong>{flaggedCount}</strong>
        </div>
        <div className="stat-card">
          <span>Saved Boards</span>
          <strong>{savedCount}</strong>
        </div>
      </div>
    </section>
  );
}
